import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import SaveSFTPSettingsComponent from './new-sftp-connection';
import { SimpleLoadingComponent } from '../../utils/apollo';
import newConnectionMutation from './new-connection-mutation';
import deleteConnectionMutation from './delete-connection-mutation';

export const query = gql`
  query SaveSFTPSettingsComponent {
    viewer {
      id
      activeMatchExportConfiguration {
        id
        isNew
        createdDate
        sftpHost
        sftpPort
        sftpPath
        sftpUsername
        sftpPassword
        authenticationType
        schedule
        modifiedBy {
          name
        }
        connectionTestSuccess
        connectionTestError {
          message
        }
        lastModified
        whitelistIPs
        publicKey
        sshKeyGeneratedAt
        sshKeyGeneratedBy {
          uuid
          name
        }
      }
      activeMatchExportTransferSummary {
        successfulJob
        createdAt
        transferFailureReason
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params }) => {
    const { id = '' } = params;
    return {
      skip: !id,
      variables: {
        id,
      },
    };
  },
});

const newSftpConnection = graphql(newConnectionMutation, {
  name: 'mutateNewSftpConnection',
  options: {
    refetchQueries: [{ query }],
    awaitRefetchQueries: true,
  },
});

const newSshKeyGen = graphql(gql`
  mutation generateSFTPKeypair($input: generateSFTPKeypairInput!) {
    generateSFTPKeypair(input: $input) {
      publicKey
    }
  }
`, {
  name: 'mutateSshKeyGen',
  options: {
    refetchQueries: [{ query }],
    awaitRefetchQueries: true,
  },
});

const deleteSftpConnection = graphql(deleteConnectionMutation, {
  name: 'mutateDeleteSftpConnection',
  options: {
    refetchQueries: [{ query }],
    awaitRefetchQueries: true,
  },
});

export default withRouter(SimpleLoadingComponent(
  graphqlData, newSftpConnection, newSshKeyGen, deleteSftpConnection,
)(SaveSFTPSettingsComponent));
